import { getFirebaseMessaging } from "./firebase-config";
import { toast } from "@/utils/appToast";
import { api } from "@/utils/api"; // your backend call
import { store } from "@/store/store"; // Redux store
import { updateUser } from "@/features/user/userSlice";


export const setupPushListener = async () => {
  if (typeof window === "undefined") return;
  const messaging = await getFirebaseMessaging();
  if (!messaging) return;
  const { onMessage } = await import("firebase/messaging");
  onMessage(messaging, async (payload) => {
    console.log("📩 Push notification received:", payload);

    const { title, body } = payload.notification || {};
    const url = payload?.data?.deepLink;
    const chatId = payload?.data?.chatId;

    // ✅ Show notification
    if ("Notification" in window && Notification.permission === "granted") {
      const notification = new Notification(title || "", {
        body,
        icon: "/images/favicon.png",
      });

      notification.onclick = () => {
        if (url) window.open(url, "_blank");
      };
    } else {
      toast.info(body, {
        icon: "🔔",
        position: "top-right",
        theme: "colored",
        onClick: () => {
          if (url) window.location.href = url;
        },
      });
    }

    // ✅ Call APIs to reset/fetch unseen message counters
  // ✅ Call APIs to reset/fetch unseen message counters
try {
  const [unseenResponse, chatResponse] = await Promise.all([
    api.getUnseenMessages().catch((err) => {
      console.error("Failed to get global unseen messages:", err);
      return { success: false };
    }),
    chatId
      ? api.getUserChatCounter(chatId).catch((err) => {
          console.error(`Failed to get counter for chat ${chatId}:`, err);
          return { success: false };
        })
      : Promise.resolve({ success: false }),
  ]);

  // Update global unseen messages in Redux
  if (unseenResponse.success && unseenResponse.data) {
    store.dispatch(
      updateUser({ unSeenMessageCounter: unseenResponse.data.unSeenMessageCounter })
    );
  }

  // Update chat-specific counter directly in user object
  if (chatResponse.success && chatResponse.data) {
    const { count } = chatResponse.data.data; // userChatCounter
    store.dispatch(
      updateUser({
        userChaTId: chatId,
        userChatCounter: count,
      })
    );

    console.log(`✅ Updated userChatCounter for chat ${chatId}:`, count);
  }
} catch (err) {
  console.error("Error updating unseen counters:", err);
}

  });
};

